import Module from '../../../../layout/Module'
import { Routes, Route, useNavigate, useParams, useLocation } from 'react-router-dom'
import Setting from './Setting/Setting'
import AlertSaveButton from '../../../../button/AlertSaveButton'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import useAnalyticsCurriculum from '../../../../../hooks/analytics/useAnalyticsCurriculum'
import useYears from '../../../../../hooks/setting/useYears'
import useSubjects from '../../../../../hooks/subjects/useSubjects'
import Current from './Current/Current'
import History from './History/History'
import { resetModule } from '../../../../../store/actions/analytics.actions'

const AnalyticsCurriculum = () => {
  const { code, studentId } = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const basePath = `/dashboard/${studentId ? `${studentId}/` : ''}analytics/${code}/analytics-curriculum`
  const roles = useSelector((state) => state?.session.user.roles?.map((r) => r.id))
  const curriculumId = useSelector(
    (state) => state?.analytics?.analyticsCurriculum?.datasets?.curriculum?._id || null
  )
  const isLoading = useSelector((state) => state?.analytics?.analyticsCurriculum?.loading || false)

  const onRedirect = (redirectTo) => {
    navigate(`${basePath}${redirectTo}`)
  }

  const { getAnalyticsCurriculumCurrent } = useAnalyticsCurriculum()

  useEffect(() => {
    getAnalyticsCurriculumCurrent()
    return () => {
      dispatch(resetModule('analyticsCurriculum'))
    }
  }, [])

  const { getYears } = useYears()
  const { getAllSubjects } = useSubjects()

  useEffect(() => {
    getYears()
  }, [])
  useEffect(() => {
    if (curriculumId) {
      getAllSubjects(curriculumId)
    }
  }, [curriculumId])

  return (
    <Module moduleName='periodical-report-vce'>
      <Module.Header title='Periodical Report VCE' titleLink={basePath}>
        {!roles.some((r) => ['Student', 'Parent'].includes(r)) && (
          <div className='flex gap-2'>
            <AlertSaveButton
              submodule='Periodical Report VCE'
              icon='cogs'
              title='Setting'
              color='secondary'
              onDontSave={() => {
                onRedirect('/setting')
              }}
              disabled={isLoading}
            />
            <div className='px-4' />
            <AlertSaveButton
              submodule='Periodical Report VCE'
              icon='th-list'
              title='History'
              color='secondary'
              onDontSave={() => {
                onRedirect('/history')
              }}
              disabled={isLoading}
            />
            <AlertSaveButton
              submodule='Periodical Report VCE'
              icon='chart-line'
              title='Report'
              color='secondary'
              onDontSave={() => {
                onRedirect('')
              }}
              disabled={isLoading}
            />
          </div>
        )}
      </Module.Header>
      <Module.Body>
        <Routes>
          <Route path='/*' element={<Current isLoading={isLoading} />} />
          <Route path='history' element={<History isLoading={isLoading} />} />
          <Route path='setting/*' Component={Setting} />
        </Routes>
      </Module.Body>
    </Module>
  )
}

export default AnalyticsCurriculum
